import { render } from "./grid_gallery.vue?vue&type=template&id=0a44ad0e"
import script from "./grid_gallery.vue?vue&type=script&lang=js"
export * from "./grid_gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__